export const ANALYTICS_ROUTE_SEGMENTS = {
  root: "analytics",
  testDashboard: "test-dashboard",
  testNewDashboard: "test-new-dashboard",
} as const;

export const ANALYTICS_PATH = `/${ANALYTICS_ROUTE_SEGMENTS.root}`;
